import { Component, h, Host, State } from '@stencil/core';

import wcShared from '@web-components/shared';

import newsStore from '../../../stores/news.store';

@Component({
  tag: 'events-news',
  styleUrl: 'events-news.scss',
  shadow: true,
})
export class EventsNews {
  @State() eventsDisplay: IWCCurrentEvents[] = wcShared.store.currentEvents;
  @State() hasMoreEvents = false;

  componentWillLoad() {
    if (wcShared.store.currentEvents?.length > 3) {
      this.eventsDisplay = wcShared.store.currentEvents?.slice(0, 3);
      this.hasMoreEvents = true;
    }
  }

  private seeMoreEvents() {
    this.eventsDisplay = wcShared.store.currentEvents;
    this.hasMoreEvents = false;
  }

  private scrollToHeader() {
    const newsEl: HTMLElement = document
      ?.querySelector('module-news-component')
      ?.shadowRoot?.querySelector('news-component')
      ?.shadowRoot?.querySelector('.scroller')
      ?.querySelector('events-news');

    newsEl?.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' });
  }

  render() {
    return (
      <Host>
        <div class="events-news">
          <div class="events-news__header">
            <div
              class="title"
              onClick={() => this.scrollToHeader()}
            >
              {wcShared?.translate('Evenements')}
              {newsStore.currentEventCount > 0 && <span>{newsStore.currentEventCount}</span>}
            </div>
          </div>

          {this.eventsDisplay?.map((item) => <item-events item={item} />)}

          {this.hasMoreEvents && (
            <div
              class="events-news__button"
              onClick={() => this.seeMoreEvents()}
            >
              <button>{wcShared?.translate('Voir tous les incidents')}</button>
            </div>
          )}
        </div>
      </Host>
    );
  }
}
